import { React, useEffect, useState } from 'react';
import { Typography, Grid } from '@mui/material';
import { OPN_LIST, LiveDatasheetDefinition } from '../../pageDefinition/LiveDatasheetDefinition';
import api from '../../api';

const GenHelp = () => {
	const [status, setStatus] = useState('');
	useEffect(() => {
		let sendParamsPromises = [];
		for (const opnKey in OPN_LIST) {
			let opn = OPN_LIST[opnKey];
			let ldd = new LiveDatasheetDefinition(opn);
			let simulations = ldd.pageDefinition.gainDefinition().simulations;
			let inputParameters = simulations.map(function (simulation) {
				return simulation.inputParameters;
			});
			sendParamsPromises.push(sendParams(inputParameters, opn));
		}
		Promise.all(sendParamsPromises).then(() => {
			setStatus('Done');
		});
	}, []);

	async function sendParams(inputParameters, opn) {
		await api.sendParams(opn, inputParameters);
	}

	return (
		<Grid
			container
			direction="column"
			alignItems="center"
			sx={{ textAlign: 'center', paddingTop: '7rem', minHeight: '80vh' }}>
			<Grid item>
				<Typography variant="h3">Resource generation status:</Typography>
			</Grid>

			<Grid item sx={{ marginTop: '2rem' }}>
				<Typography variant="h3">{status}</Typography>
			</Grid>
		</Grid>
	);
};

export default GenHelp;
